import { filterString } from './results-query';
import { buildMapFilter } from './results-query';
import { filterCity, filterZone, filterPrice } from './results-prefilters';
import { filterSort, filterNid, filterIndex } from './results-query';
import { fieldsBuilder } from '../../builder-filter';
import { fields } from '../filters/filters';
export async function sendResultsFilters(isBuilder) {
    const fieldsData = isBuilder ? fieldsBuilder : fields;
    let filter = filterString();
    filter += filter
        ? `&url=${window.location.pathname}`
        : `?url=${window.location.pathname}`;
    filter = filterCity(filter);
    filter = filterZone(filter);
    filter = filterPrice(filter);
    filter = filterSort(filter);
    filter = filterNid(filter);
    filter = filterIndex(filter);
    const response = await fetch(`/results-filters${filter}`);
    const data = await response.json();
    const urlParams = new URLSearchParams(filter);
    ['cities', 'zone', 'sector'].forEach((param) => {
        const value = urlParams.get(param);
        const inputElement = fieldsData[param];
        if (value && inputElement) {
            inputElement.value = value;
        }
    });
    return data;
}
export async function fetchMapResults() {
    const filter = buildMapFilter();
    const separator = filter ? '&' : '?';
    const response = await fetch(`/results-api/map${filter}${separator}range=100`);
    return await response.json();
}
